import { useState } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import MenuItem from './MenuItem'
import s from './Header.module.scss'

const DropdownPuppies = dynamic(() => import('./MultipleDropDownMenu'))
const DropDowAbout = dynamic(() => import('./MenuItemDropDown'))

interface DesktopMenuProps {
  userData: any
}

export default function DesktopMenu({ userData }: DesktopMenuProps) {
  const router = useRouter()
  const [showPuppiesModal, setShowPuppiesModal] = useState(false)
  const [showAboutUsModal, setShowAboutUsModal] = useState(false)

  return (
    <>
      <div
        className={s.buttons}
        onMouseEnter={() => setShowPuppiesModal(true)}
        onMouseLeave={() => setShowPuppiesModal(false)}
        onClick={() => setShowPuppiesModal(true)}
      >
        <div className={s.buttonContainer2}>
          <div className={s.puppiesOption}>
            <MenuItem
              title="Available Puppies"
              path={router.pathname}
              href="puppies"
            />
          </div>
          {showPuppiesModal && (
            <DropdownPuppies
              onOutsideClick={() => setShowPuppiesModal(false)}
            />
          )}
        </div>
      </div>

      <div
        className={s.buttons}
        onMouseEnter={() => setShowAboutUsModal(true)}
        onMouseLeave={() => setShowAboutUsModal(false)}
        onClick={() => setShowAboutUsModal(true)}
      >
        <div className={s.buttonContainer2}>
          <div className={s.puppiesOption}>
            <MenuItem title="About Us" path={router.pathname} href="about-us" />
          </div>

          {showAboutUsModal && (
            <DropDowAbout
              userData={userData}
              onOutsideClick={() => setShowAboutUsModal(false)}
            />
          )}
        </div>
      </div>

      <MenuItem
        title="Puppy Match Quiz"
        href="/dog-breed-quiz"
        path={router.pathname}
      />

      <MenuItem title="Blog" href="/blog" path={router.pathname} />
    </>
  )
}
